export default "__VITE_ASSET__BQ5UkNMt__"